import PoliciesLinks from "./PoliciesLinks";

export default PoliciesLinks;
